import { ValidationMessage, ValidationProps } from 'ui';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { SubscriberGroupItemValidation } from 'app/area/subscriber-groups/form/types-store';

export const clearValidationForKeys = (
  validation: SubscriberGroupItemValidation,
  keys: (keyof SubscriberGroupItemValidation)[]
): SubscriberGroupItemValidation => {

  if (!validation ||
    !Object.keys(validation).some(key => (validation?.[key]?.messages?.length ?? 0) > 0)) {
    return validation;
  }

  return Object.keys(validation).reduce((currentValidation, currentKey) =>
    keys.includes(currentKey as keyof SubscriberGroupItemValidation)
      ? currentValidation
      : {
        ...currentValidation,
        [currentKey]: validation[currentKey]
      }, {});
};

export const clearValidationForSingleParameter = (
  validation: SubscriberGroupItemValidation,
  key: string,
  parameter: string,
  id: number
): SubscriberGroupItemValidation => {
  if (!validation ||
    (Array.isArray(validation[key])
      ? ((validation[key] as ValidationProps[])?.find(validationProps => (validationProps.messages?.length ?? 0) === 0))
      : ((validation[key] as ValidationProps)?.messages?.length ?? 0) === 0)) {
    return validation;
  }

  const messages = (Array.isArray(validation[key])
    ? (validation[key] as ValidationProps[]).flatMap(message => message.messages)
    : (validation[key] as ValidationProps).messages).filter(
      (m: ValidationMessage) => !m || !m.parameters ||
        !isDefinedIncludingZero(m.parameters[parameter]) || m.parameters[parameter] !== id);

  if (messages.length === 0) {
    const { [key as keyof SubscriberGroupItemValidation]: _, ...validationRest } = validation;

    return validationRest;
  }

  return {
    ...validation,
    [key]: {
      ...validation[key],
      messages
    }
  };
};

export const clearValidationForAllParameters = (
  validation: SubscriberGroupItemValidation,
  key: string,
  parameter: string
): SubscriberGroupItemValidation => {
  if (!validation ||
    (Array.isArray(validation[key])
      ? ((validation[key] as ValidationProps[])?.find(validationProps => (validationProps.messages?.length ?? 0) === 0))
      : ((validation[key] as ValidationProps)?.messages?.length ?? 0) === 0)) {
    return validation;
  }

  const messages = (Array.isArray(validation[key])
    ? (validation[key] as ValidationProps[]).flatMap(message => message.messages)
    : (validation[key] as ValidationProps).messages).filter(
      (m: ValidationMessage) => !m || !m.parameters || !isDefinedIncludingZero(m.parameters[parameter]));

  if (messages.length === 0) {
    const { [key as keyof SubscriberGroupItemValidation]: _, ...validationRest } = validation;

    return validationRest;
  }

  return {
    ...validation,
    [key]: {
      ...validation[key],
      messages
    }
  };
};
